<template>
    <div>
        <p style="height:1000px;">ABOUT</p>
        <p>ABOUT</p>
    </div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
	name: 'about',
	data() {
		return {
			
		}
	},
}
</script>

<style scoped>
.wrapper {
    width: 100%;
    display: flex;
    color:black;
    font-size: 16px;
    letter-spacing: .05em;
    gap: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/About.vue